var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 mb-14",attrs:{"fluid":""}},[(_vm.title)?_c('section-title',{attrs:{"title":_vm.title}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }